module.exports = __webpack_public_path__ + "static/media/banner-video.6ee8dcdd.mp4";